import Styled from 'styled-components';
import Button from '~/components/Button';

export default Styled(Button)`
  background: white;
`;
